import { FunctionForm } from "@/components/FunctionsModal/FunctionForm";

const FunctionEditorDialog: React.FC = () => <FunctionForm />;

export default FunctionEditorDialog;
